<template>
  <v-date-picker
    :value="value"
    :formats="{ input: format }"
    :min-date="minDate"
    :max-date="maxDate"
    popover-visibility="focus"
    title-transition="none"
    weeks-transition="none"
    @input="handleClickInput($event)"
  >
    <template slot-scope="{ inputValue }">
      <div class="form-date-picker" :class="type">
        <div class="icon-container">
          <font-awesome-icon icon="calendar-alt" />
        </div>
        <input
          ref="formDateInput"
          :value="inputValue"
          :placeholder="placeholder"
          @change="handleKeyInput($event)"
        />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
import { dateUtils } from '@/mixins/date-utils';
export default {
  name: 'FormDatePicker',
  mixins: [dateUtils],
  inheritAttrs: false,
  props: {
    value: {
      type: [Date, String],
      default: null
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    placeholder: {
      type: String,
      default: 'Date'
    },
    type: {
      type: String,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    }
  },
  methods: {
    handleKeyInput(evt) {
      this.$emit('change', evt.target.value);
    },
    handleClickInput(evt) {
      //if we click on the currently selected value, the event will be null
      //we want to still emit a change event to parent, with the currently selected value
      let val;
      if (!evt) {
        val = this.dateFromString(this.$refs.formDateInput.value);
      } else {
        val = evt;
      }
      this.$emit('change', val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.form-date-picker {
  display: flex;
  align-items: center;
  border-bottom: 1px solid $blue;
  flex-grow: 1;

  svg {
    font-size: 1.3em;
    margin-right: 10px;
  }
  input {
    border: 0;
    width: 100%;
    height: 100%;
    font-size: 0.9em;
    padding: 8px 0;
    &:focus {
      outline: none;
    }
    &:disabled {
      background-color: $light-grey-2;
    }
  }
  &.small {
    width: auto;
    display: inline-flex;
    margin-right: 15px;
  }

  &.bordered {
    border: 1px solid $blue;
    height: 40px;
    .icon-container {
      display: flex;
      width: 40px;
      justify-content: center;
      height: 100%;
      align-items: center;
      border-right: 1px solid $blue;
      margin-right: 8px;
      svg {
        margin: 0;
        padding: 0;
      }
    }

    &.error {
      background-color: $modified-form;
      input {
        background-color: $modified-form;
      }
    }
  }
}
</style>
